import WorkingHours from "./WorkingHours";
import Info from "../../../../../assets/settings/Info.svg";
import WorkingsHoursEdit from "./WorkingsHoursEdit";
import { useIntl } from "react-intl";
const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const EditWorkingsHours = ({ isEdit, form, opening_hours }: any) => {
  console.log(isEdit);
  console.log(opening_hours);

  const filterOpeningHours = (e?: any) => {
    const openingHoursMap = new Map(
      opening_hours?.map((day: any) => [day.day, day])
    );
    const result = daysOfWeek?.map((day) => {
      const existingDay = openingHoursMap?.get(day);
      if (existingDay) {
        return { ...existingDay, off: false };
      } else {
        return {
          day,
          opening_time: "00:09:00",
          closing_time: "00:17:00",
          off: true,
        }; // Assuming day is the name of the day of the week
      }
    });

    return result;
  };
  const intl = useIntl();
  return (
    <div className="flex flex-col items-center justify-center w-full text-center col-span-2 py-4">
      {!isEdit ? (
        <>
          <div className="justify-self-start w-full text-right text-base text-black font-semibold">
            {intl.formatMessage({ id: "branchWorkingHours" })}
          </div>
          <div className="flex overflow-auto items-center justify-between w-full col-span-2 gap-4">
            {filterOpeningHours()?.map(
              ({ day, opening_time, closing_time }: any) => (
                <WorkingHours
                  day={day}
                  start={opening_time}
                  end={closing_time}
                />
              )
            )}
          </div>
          <div className="text-[#4F5062] text-sm w-full flex items-center justify-center gap-2 mx-auto">
            <img src={Info} className="w-4 h-4" alt="" />
            <span className="text-[#4F5062]">
              {intl.formatMessage({ id: "workingHoursNote" })}
            </span>
          </div>
        </>
      ) : (
        <div className=" grid grid-cols-2 max-lg:grid-cols-1 w-full p-4 px-3 items-start justify-bet bg-[#FBFBFF] rounded-lg">
          {filterOpeningHours()?.map(
            ({ day, opening_time, closing_time, off }: any, index: number) => (
              <WorkingsHoursEdit
                form={form}
                day={day}
                opening_time={opening_time}
                closing_time={closing_time}
                off={off}
                index={index}
              />
            )
          )}
        </div>
      )}
    </div>
  );
};

export default EditWorkingsHours;
